import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const LinkButton = ({ to, testId, children, variant = "solid", className = "" }) => {
  const styles = {
    solid: "bg-[#a8792a] px-6 py-3.5 text-white hover:bg-[#8e6520]",
    outline: "border border-[#221e1b]/25 px-6 py-3.5 text-[#221e1b] hover:border-[#a8792a] hover:text-[#7a5615]",
    text: "text-[#221e1b] underline decoration-[#a8792a]/50 underline-offset-[6px] hover:decoration-[#a8792a] px-0",
  };
  return (
    <Link
      to={to}
      data-testid={testId}
      className={`group inline-flex min-h-12 max-w-full items-center justify-center gap-2 rounded-full text-center text-sm font-semibold leading-snug transition-colors duration-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#7a5615] sm:text-base ${styles[variant]} ${className}`}
    >
      {children}
      <ArrowRight aria-hidden="true" className="h-4 w-4 shrink-0 transition-transform duration-300 group-hover:translate-x-1" />
    </Link>
  );
};
